// GENERATED from ez-tree preset "Pine Large" — Scripts/EzTree/PresetConverter.js
// Rerun (to see the drift vs. upstream ez-tree): npm start client.eztree.convertPresets
// NOT read-only: hand tweaks are expected; the converter is just the starting point.
//
// Sizing: targetHeight (metres) is THE scale knob — the generator scales the mesh uniformly to
// that height (unset = the root's default). value = rawHeight × ezTreeUnitToMeters, so the preset
// keeps its natural proportions (× 1.1 on value = +10% overall size); `swing` varies the height
// ±its fraction across the kind's variants. Both numbers are meant to be hand-tweaked.
// footprintRadiusRatio = observed width / observed height; resolved footprint radius =
// targetHeight × footprintRadiusRatio (so resizing via targetHeight keeps width proportional).
import {SceneryKindDef} from "../../@SceneryTypes.js";
import {EZTREE_ROOT_KIND_ID} from "../Kind_EzTree.js";

export const PineLarge_KIND_ID = "ezTree_PineLarge";

export const PineLargeKind = new SceneryKindDef({
	id: "ezTree_PineLarge",
	name: "Pine Large",
	baseKindID: EZTREE_ROOT_KIND_ID,
	// Only the flat keys differing from the root's defaults (TreeOptions ctor defaults) are set —
	// everything else inherits the root.
	paramOverrides: {
		"branchLevels": 1,
		"branchAngle1": 129.1304347826087,
		"branchAngle2": 16,
		"branchChildren0": 100,
		"branchChildren1": 3,
		"branchChildren2": 0,
		"branchGnarliness0": 0.05,
		"branchGnarliness1": 0.08,
		"branchGnarliness2": 0,
		"branchGnarliness3": 0,
		"branchLength0": 65.25217391304348,
		"branchLength1": 34.84782608695652,
		"branchLength2": 27.246739130434783,
		"branchRadius0": 1.271739130434783,
		"branchRadius1": 0.366304347826087,
		"branchStart1": 0.29347826086956524,
		"branchStart2": 0.14,
		"treeType": "evergreen",
		"leafCount": 18,
		"leafSize": 2.608695652173913,
		"leafSizeVariance": 0.201,
		"leafAngle": 17,
		"leafStart": 0.07608695652173914,
		"leafAlphaTest": 0.3,
		"leafType": "pine",
		"barkType": "Bark003",
		"forceStrength": 0.009000000000000001,
		"targetHeight": 17.07,
	},
	footprintRadiusRatio: 0.347,
});
